import request from '@/Network/Requests/request'
import Service from '@/Network/Services/Service'
import { ServiceError } from '@/utils/apiError'
import {
  NpsPublicDoctorSearchParams,
  NpsPublicDoctorSearchResponse,
  NpsPublicFormResponse
} from '@/Network/Types/Responses/NpsPublicFormResponses'
import { SubmitNpsPublic } from '@/Network/Types/Requests/NpsRequests'

export default class NpsPublicFormService extends Service {
  prefix = '/nps/public'

  async getForm(healthUnitId: number, surveyId?: number): Promise<NpsPublicFormResponse> {
    const params = surveyId ? { surveyId } : undefined
    let data: NpsPublicFormResponse | NpsPublicFormResponse[]
    try {
      const response = await request.get<NpsPublicFormResponse | NpsPublicFormResponse[]>(
        `${this.getCompletePath()}/health-unit/${healthUnitId}`,
        params
      )
      data = response.data
    } catch (e) {
      throw this.handleError(e, 'Não foi possível carregar o formulário.')
    }
    if (Array.isArray(data)) {
      if (data.length === 0)
        throw new ServiceError('Nenhum formulário vigente encontrado para esta unidade.', data)
      return data[0]
    }
    return data
  }

  /**
   * Busca "Outro médico" do formulário público (modo edital): base do Minha Escala
   * (`source=BASE`) ou base CFM local (`source=CFM`). Público e com throttle por IP
   * no backend; o 429 chega ao consumidor via `ServiceError.originalError`.
   */
  async searchDoctors(
    healthUnitId: number,
    params: NpsPublicDoctorSearchParams
  ): Promise<NpsPublicDoctorSearchResponse> {
    try {
      const { data } = await request.get<NpsPublicDoctorSearchResponse>(
        `${this.getCompletePath()}/health-unit/${healthUnitId}/doctors/search`,
        params
      )
      return data
    } catch (e) {
      throw this.handleError(e, 'Não foi possível buscar médicos agora.')
    }
  }

  async submit(payload: SubmitNpsPublic): Promise<{ submissionId: number; answersCount: number }> {
    const { data } = await request.post<{ submissionId: number; answersCount: number }>(
      `${this.getCompletePath()}/submit`,
      payload
    )
    return data
  }
}
